import React, { useState } from 'react';
import { EyeIcon, EyeSlashIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function FormField({ label, name, type, value, autoComplete, onChange, onBlur, required, readOnly, autoFocus, onClear }) {
    const [passwordVisible, setPasswordVisible] = useState(false);

    return (
        <div className="mb-4">
            <label className="block text-orange-300 text-sm mb-2" htmlFor={name}>
                {label}:
            </label>
            <div className="relative">
                { readOnly ?
                    <label
                        className="flex w-full px-3 py-2 bg-gray-700 text-gray-200 rounded-lg"
                    >
                        {value ?? ''}
                    </label> :
                    <input
                        type={type !== "password" ? type : (passwordVisible ? "text" : "password")}
                        id={name}
                        name={name}
                        autoComplete={autoComplete ?? name}
                        placeholder={label}
                        value={value ?? ''}
                        onChange={onChange}
                        onBlur={onBlur}
                        className={`w-full px-3 py-2 border bg-gray-700 text-gray-200 rounded-lg focus:ring-2 focus:ring-orange-300
                            ${name === 'url'
                                ? ''
                                : ''
                            }
                            `}
                        required = {required}
                        readOnly = {readOnly}
                        autoFocus = {autoFocus}
                    />
                }
                {name.includes("password") &&
                    <button
                        type="button"
                        onClick={() => setPasswordVisible(!passwordVisible)}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                    >
                        {passwordVisible ? (
                            <EyeIcon className="h-5 w-5 text-gray-200" />
                        ) : (
                            <EyeSlashIcon className="h-5 w-5 text-gray-200" />
                        )}
                    </button>
                }
                {onClear &&
                    <button
                        type="button"
                        onClick={onClear}
                        className="absolute inset-y-0 right-0 pr-2 flex items-center text-sm leading-5"
                    >
                        <XMarkIcon className="h-5 w-5 text-gray-200 bg-gray-700" />
                    </button>
                }
            </div>
        </div>
    )
}
